var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-check"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","id":_vm.checkboxId},on:{"change":_vm.onChange}}),_vm._v(" "),_c('label',{staticClass:"form-check-label paragraph-reduced",attrs:{"for":_vm.checkboxId,"tabindex":"0"},on:{"keydown":_vm.onChangeKeyEvent}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }